<script setup>
import fiveMixin from '@/composables/fiveMixin';
import useFunctions from '@/composables/useFunctions';
import { useDeviceDetect } from '@/composables/useDeviceDetect';

const { isMobile } = useDeviceDetect();
const { ...five } = fiveMixin();
const { ...useFun } = useFunctions();

// 사주 컬럼 sticky: CSS position: sticky로 처리 (JS scroll 이벤트 제거)
const sajuContainerRef = ref(null);

const props = defineProps({
  prBirthData: {
    type: Object,
    default: null,
  },
  prBirthJijanggan: {
    type: Object,
    default: () => ({}),
  },
  prLangMode: {
    type: String,
    default: '',
  },
  prBirthTitle: {
    type: String,
    default: '',
  },
  prType: {
    type: String,
    default: '',
  },
  prCurDaeun: {
    type: Object,
    default: () => ({}),
  },
  prCurSeun: {
    type: Object,
    default: () => ({}),
  },
  prTransdata: {
    type: Object,
    default: () => ({}),
  },
  isActive: {
    type: Boolean,
    default: false,
  },
  selectedData: {
    type: Object,
    default: () => ({}),
  },
  sortMode: {
    type: String,
    default: 'desc',
  },
});

// asc일 때 현재대운이 왼쪽(먼저), 현재세운이 오른쪽(나중)
const isAsc = computed(() => props.sortMode === 'asc');

const localCurDaeun = ref(null);

// 처음 조회된 세운 연도 저장
const initialSeunYear = ref(null);

// 세운 헤더 텍스트 (처음 조회된 연도면 "현재세운", 아니면 연도만 표시)
const seunHeaderText = computed(() => {
  const seunYear = props.prCurSeun?.year;
  const isChnOnly = props.prLangMode === 'CHN';
  if (!seunYear) return isChnOnly ? '現在歲運' : '현재세운';

  // 처음 조회된 연도 저장
  if (initialSeunYear.value === null) {
    initialSeunYear.value = seunYear;
  }

  return seunYear === initialSeunYear.value
    ? (isChnOnly ? '現在歲運' : '현재세운')
    : String(seunYear);
});

// 현재대운 헤더 텍스트
const daeunHeaderText = computed(() => {
  const isChnOnly = props.prLangMode === 'CHN';
  return isChnOnly ? '現在大運' : '현재대운';
});

const daeunSuffix = computed(() => {
  const isChnOnly = props.prLangMode === 'CHN';
  return isChnOnly ? '大運' : '대운';
});

onMounted(() => {
  //setCurDaeun(prCurDaeun);
  // console.log('mansebirth에서', props.prBirthData)

});

const setCurDaeun = (curDaeun) => {
  localCurDaeun.value = curDaeun;
};
function getCurDaeunNum(data) {
  if (data) {
    return data[0]?.num;
  }
  return '';
}

function getYearSix(data, pos) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.six;
  return txt;
}
// 한글↔한자 타이틀 매핑
const titleHanjaMap = {
  '시': '時', '일': '日', '월': '月', '년': '年',
  '時': '時', '日': '日', '月': '月', '年': '年',
};

// langMode에 따라 타이틀 글자를 한자 또는 한글로 변환
const getDisplayTitle = (char) => {
  if (props.prLangMode === 'CHN') {
    return titleHanjaMap[char] || char;
  }
  return char;
};

function getPosEng(pos) {
  let txt = '';
  if (pos === '년' || pos === '年') txt = 'year';
  if (pos === '월' || pos === '月') txt = 'month';
  if (pos === '일' || pos === '日') txt = 'day';
  if (pos === '시' || pos === '時') txt = 'hour';
  return txt;
}
function getValueTxt(data, pos, val) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.[val];
  if (val === 'sal') {
    txt = txt ? txt[0] : '';
  }
  return txt;
}
function getValueTxtOne(data, pos, val, index) {
  let txt = '';
  const posEng = getPosEng(pos);
  txt = data?.[posEng]?.[val]?.[index];
  return txt;
}
function getYearSixD(data, pos) {
  let txt = '';
  if (data && data.length > 0) {
    txt = data?.[pos][0]?.six;
  }
  return txt;
}
function getValueTxtD(data, val) {
  let txt = '';
  if (data && data.length > 0) {
    txt = data[0]?.[val];
    if (val === 'sal') {
      txt = txt ? txt[0] : '';
    }
  }
  return txt;
}
function getValueTxtDOne(data, val, index) {
  let txt = '';
  if (data && data.length > 0) {
    txt = data[0]?.[val]?.[index];
  }
  return txt;
}

// 오행도 클릭에 따른 스타일 적용
const getGlobalIdx = (type, title, prBirthTitle) => {
  const posEng = getPosEng(title);
  const idxMap = {
    sky: { year: 0, month: 1, day: 2, hour: 3 },
    earth: { year: 4, month: 5, day: 6, hour: 7 },
  };
  // 현재 prBirthTitle에서 title의 위치 찾기
  const titleIndex = prBirthTitle.indexOf(title);
  if (titleIndex === -1) return null;
  // 해당 title에 맞는 globalIdx 반환
  return idxMap[type][posEng];
};
// const getClass = (type, title, prBirthTitle) => {
//   if (!props.isActive || props.selectedData === null) return ''; // 기본 스타일
//   // 현재 요소의 globalIdx 계산
//   const currentIdx = getGlobalIdx(type, title, prBirthTitle);
//   // 선택된 globalIdx와 비교
//   return currentIdx === props.selectedData ? '' : 'inactive-wongook';
// };
const getClass = (type, title, prBirthTitle) => {
  if (!props.isActive || props.selectedData === null) return ''; // 기본 스타일
  const currentIdx = getGlobalIdx(type, title, prBirthTitle);
  // 조건별 클래스 추가
  const classes = [];
  if (currentIdx === props.selectedData) {
    if (currentIdx === 2) {
      // sky의 day일 경우 특별 스타일 적용
      classes.push('ilgan');
    }
  } else {
    // 매칭되지 않은 요소
    classes.push('inactive-wongook');
  }
  return classes.join(' ');
};
</script>

<template>
  <!-- 모바일 sticky 사주 컬럼 - CSS position: sticky로 대체, JS 복제 비활성화 -->
  <div
    v-show="false"
    class="saju-sticky-columns"
  >
    <div class="saju-sticky-columns__inner">
      <!-- 현재세운 컬럼 (sticky) -->
      <ul
        v-if="prCurSeun?.sky?.length > 0"
        class="birth-item-box birth bg-line txt-big cur-seun-col"
        :class="{ 'has-divider': isAsc }"
        :style="{ order: isAsc ? 1 : 0 }"
      >
        <li>
          <span class="txt1">{{ seunHeaderText }}</span>
        </li>
        <li>
          <span class="txts">{{ getValueTxtD(prCurSeun.sky, 'six') }}</span>
        </li>
        <li>
          <span
            class="txt-round xl"
            :class="[
              five.getColorFive(getValueTxtD(prCurSeun.sky, 'value')),
              prLangMode === 'CHNKOR' ? 'chnkor' : '',
              prLangMode,
            ]"
          >
            <em v-if="prLangMode === 'CHNKOR'" class="chn">
              {{ five.getHanjaTxt(getValueTxtD(prCurSeun.sky, 'value'), 'sky') }}
            </em>
            <em class="txt-main">{{ getValueTxtD(prCurSeun.sky, 'value') }}</em>
          </span>
        </li>
        <li>
          <span
            class="txt-round xl mb6"
            :class="[
              five.getColorFive(getValueTxtD(prCurSeun.earth, 'value')),
              prLangMode === 'CHNKOR' ? 'chnkor' : '',
              prLangMode,
            ]"
          >
            <em v-if="prLangMode === 'CHNKOR'" class="chn">
              {{ five.getHanjaTxt(getValueTxtD(prCurSeun.earth, 'value'), 'earth') }}
            </em>
            <em class="txt-main">{{ getValueTxtD(prCurSeun.earth, 'value') }}</em>
          </span>
        </li>
        <li>
          <span class="txts">{{ getValueTxtD(prCurSeun.earth, 'six') }}</span>
        </li>
        <li class="st-none-ys">
          <span class="txts txt-earth-02">{{ getValueTxtD(prCurSeun.earth, 'twelve') }}</span>
        </li>
        <li class="st-none-ys">
          <span class="txts txt-earth-02">{{ getValueTxtD(prCurSeun.earth, 'sal') }}</span>
        </li>
        <li class="jijangan">
          <span class="txt-group-root">
            <span
              v-for="(item, index2) in getValueTxtD(prCurSeun.earth, 'jijanggansix')"
              :key="index2"
              class="txt-group"
            >
              <em
                class="txt-big ganji-txt"
                :class="[
                  five.getColorFive(getValueTxtDOne(prCurSeun.earth, 'jijanggan', index2)),
                  prLangMode === 'CHNKOR' ? 'chnkor' : '',
                ]"
                >{{ getValueTxtDOne(prCurSeun.earth, 'jijanggan', index2) }}</em
              >
              <em class="txt-small">{{ item }}</em>
            </span>
          </span>
        </li>
      </ul>
      <!-- 현재대운 컬럼 (sticky) -->
      <ul class="birth-item-box birth bg-line txt-big cur-daeun-col" :class="{ 'has-divider': !isAsc }" :style="{ order: isAsc ? 0 : 1 }">
        <li>
          <span v-if="getCurDaeunNum(prCurDaeun.sky) === prTransdata?.curlucknum" class="txt1">
            {{ daeunHeaderText }}
          </span>
          <span v-else class="txt1"> {{ getCurDaeunNum(prCurDaeun.sky) }} {{ daeunSuffix }} </span>
        </li>
        <li>
          <span class="txts">{{ getValueTxtD(prCurDaeun.sky, 'six') }}</span>
        </li>
        <li>
          <span
            class="txt-round xl"
            :class="[
              five.getColorFive(getValueTxtD(prCurDaeun.sky, 'value')),
              prLangMode === 'CHNKOR' ? 'chnkor' : '',
              prLangMode,
            ]"
          >
            <em v-if="prLangMode === 'CHNKOR'" class="chn">
              {{ five.getHanjaTxt(getValueTxtD(prCurDaeun.sky, 'value'), 'sky') }}
            </em>
            <em class="txt-main">{{ getValueTxtD(prCurDaeun.sky, 'value') }}</em>
          </span>
        </li>
        <li>
          <span
            class="txt-round xl mb6"
            :class="[
              five.getColorFive(getValueTxtD(prCurDaeun.earth, 'value')),
              prLangMode === 'CHNKOR' ? 'chnkor' : '',
              prLangMode,
            ]"
          >
            <em v-if="prLangMode === 'CHNKOR'" class="chn">
              {{ five.getHanjaTxt(getValueTxtD(prCurDaeun.earth, 'value'), 'earth') }}
            </em>
            <em class="txt-main">{{ getValueTxtD(prCurDaeun.earth, 'value') }}</em>
          </span>
        </li>
        <li>
          <span class="txts">{{ getValueTxtD(prCurDaeun.earth, 'six') }}</span>
        </li>
        <li class="st-none-ys">
          <span class="txts txt-earth-02">{{ getValueTxtD(prCurDaeun.earth, 'twelve') }}</span>
        </li>
        <li class="st-none-ys">
          <span class="txts txt-earth-02">{{ getValueTxtD(prCurDaeun.earth, 'sal') }}</span>
        </li>
        <li class="jijangan">
          <span class="txt-group-root">
            <span
              v-for="(item, index2) in getValueTxtD(prCurDaeun.earth, 'jijanggansix')"
              :key="index2"
              class="txt-group"
            >
              <em
                class="txt-big ganji-txt"
                :class="[
                  five.getColorFive(getValueTxtDOne(prCurDaeun.earth, 'jijanggan', index2)),
                  prLangMode === 'CHNKOR' ? 'chnkor' : '',
                ]"
                >{{ getValueTxtDOne(prCurDaeun.earth, 'jijanggan', index2) }}</em
              >
              <em class="txt-small">{{ item }}</em>
            </span>
          </span>
        </li>
      </ul>
      <!-- 사주 4주 컬럼 (sticky) -->
      <ul
        v-for="(char, index) in prBirthTitle"
        :key="'sticky-col-' + index"
        class="birth-item-box birth txt-big"
        :style="{ order: index + 2 }"
      >
        <li>
          <span class="txt1">{{ getDisplayTitle(char) }}</span>
        </li>
        <li>
          <span class="txts">{{ getYearSix(prBirthData?.sky, char) }}</span>
        </li>
        <li>
          <span
            class="txt-round xl"
            :class="[
              five.getColorFive(getValueTxt(prBirthData?.sky, char, 'value')),
              getClass('sky', char, prBirthTitle),
              prLangMode === 'CHNKOR' ? 'chnkor' : '',
              prLangMode,
            ]"
          >
            <em v-if="prLangMode === 'CHNKOR'" class="chn">
              {{ five.getHanjaTxt(getValueTxt(prBirthData?.sky, char, 'value'), 'sky') }}
            </em>
            <em v-if="getValueTxt(prBirthData?.sky, char, 'value') === '-'" class="time-none">{{
              getValueTxt(prBirthData?.sky, char, 'value')
            }}</em>
            <em v-else class="txt-main">{{ getValueTxt(prBirthData?.sky, char, 'value') }}</em>
          </span>
        </li>
        <li>
          <span
            class="txt-round xl mb6"
            :class="[
              five.getColorFive(getValueTxt(prBirthData?.earth, char, 'value')),
              getClass('earth', char, prBirthTitle),
              prLangMode === 'CHNKOR' ? 'chnkor' : '',
              prLangMode,
            ]"
          >
            <em v-if="prLangMode === 'CHNKOR'" class="chn">
              {{ five.getHanjaTxt(getValueTxt(prBirthData?.earth, char, 'value'), 'earth') }}
            </em>
            <em v-if="getValueTxt(prBirthData?.sky, char, 'value') === '-'" class="time-none">{{
              getValueTxt(prBirthData?.sky, char, 'value')
            }}</em>
            <em v-else class="txt-main">{{ getValueTxt(prBirthData?.earth, char, 'value') }}</em>
          </span>
        </li>
        <li>
          <span class="txts">{{ getYearSix(prBirthData?.earth, char) }}</span>
        </li>
        <li class="st-none-ys">
          <span class="txts txt-earth-02">{{
            getValueTxt(prBirthData?.earth, char, 'twelve')
          }}</span>
        </li>
        <li class="st-none-ys">
          <span class="txts txt-earth-02">{{ getValueTxt(prBirthData?.earth, char, 'sal') }}</span>
        </li>
        <li class="jijangan">
          <span class="txt-xs txt-group-root">
            <span
              v-for="(item, index2) in getValueTxt(prBirthJijanggan, char, 'six')"
              :key="index2"
              class="txt-group"
            >
              <em v-if="char === '시' && item === '-'" class="txt-big ganji-txt">{{ item }}</em>
              <em
                v-if="char !== '시' || item !== '-'"
                class="txt-big ganji-txt"
                :class="[
                  five.getColorFive(getValueTxtOne(prBirthJijanggan, char, 'jiji', index2)),
                  prLangMode === 'CHNKOR' ? 'chnkor' : '',
                ]"
                >{{ getValueTxtOne(prBirthJijanggan, char, 'jiji', index2) }}</em
              >
              <em v-if="char !== '시' || item !== '-'" class="txt-small">{{ item }}</em>
            </span>
          </span>
        </li>
      </ul>
    </div>
  </div>

  <div
    ref="sajuContainerRef"
    class="data-0101-box"
    :class="{ mobile: isMobile }"
    @touchstart.stop
    @touchmove.stop
    @touchend.stop
    @mousedown.stop
    @mousemove.stop
    @mouseup.stop
  >
    <div class="mobile-inner-wrap">
    <!-- 십성/천간/지지 라벨 (PC에서만 표시) -->
    <div v-if="!isMobile" class="birth-tit-box" style="order: -1">
      <li class="row01 row-box">
        <span>십성</span>
      </li>
      <li class="row02 row-box">
        <span>천간</span>
      </li>
      <li class="row03 row-box">
        <span>지지</span>
      </li>
      <li class="row04 row-box">
        <span>십성</span>
      </li>
      <li class="row05 row-box st-none-ys">
        <span>십이운성</span>
      </li>
      <li class="row06 row-box st-none-ys">
        <span>십이신살</span>
      </li>
      <li class="row07 row-box">
        <span>지장간</span>
      </li>
    </div>
    <!-- 현재세운 컬럼 -->
    <ul v-if="prCurSeun?.sky?.length > 0" class="birth-item-box birth bg-line txt-big cur-seun-col" :class="{ 'has-divider': isAsc }" :style="{ order: isAsc ? 1 : 0 }">
      <li>
        <span class="txt1">{{ seunHeaderText }}</span>
      </li>
      <li>
        <span class="txts">{{ getValueTxtD(prCurSeun.sky, 'six') }}</span>
      </li>
      <li>
        <span
          class="txt-round xl"
          :class="[
            five.getColorFive(getValueTxtD(prCurSeun.sky, 'value')),
            prLangMode === 'CHNKOR' ? 'chnkor' : '',
            prLangMode,
          ]"
        >
          <em v-if="prLangMode === 'CHNKOR'" class="chn">
            {{ five.getHanjaTxt(getValueTxtD(prCurSeun.sky, 'value'), 'sky') }}
          </em>
          <em class="txt-main">{{ getValueTxtD(prCurSeun.sky, 'value') }}</em>
        </span>
      </li>
      <li>
        <span
          class="txt-round xl mb6"
          :class="[
            five.getColorFive(getValueTxtD(prCurSeun.earth, 'value')),
            prLangMode === 'CHNKOR' ? 'chnkor' : '',
            prLangMode,
          ]"
        >
          <em v-if="prLangMode === 'CHNKOR'" class="chn">
            {{ five.getHanjaTxt(getValueTxtD(prCurSeun.earth, 'value'), 'earth') }}
          </em>
          <em class="txt-main">{{ getValueTxtD(prCurSeun.earth, 'value') }}</em>
        </span>
      </li>
      <li>
        <span class="txts">{{ getValueTxtD(prCurSeun.earth, 'six') }}</span>
      </li>
      <li class="st-none-ys">
        <span class="txts txt-earth-02">{{ getValueTxtD(prCurSeun.earth, 'twelve') }}</span>
      </li>
      <li class="st-none-ys">
        <span class="txts txt-earth-02">{{ getValueTxtD(prCurSeun.earth, 'sal') }}</span>
      </li>
      <li class="jijangan">
        <span class="txt-group-root">
          <span
            v-for="(item, index2) in getValueTxtD(prCurSeun.earth, 'jijanggansix')"
            :key="index2"
            class="txt-group"
          >
            <em
              class="txt-big ganji-txt"
              :class="[
                five.getColorFive(getValueTxtDOne(prCurSeun.earth, 'jijanggan', index2)),
                prLangMode === 'CHNKOR' ? 'chnkor' : '',
              ]"
              >{{ getValueTxtDOne(prCurSeun.earth, 'jijanggan', index2) }}</em
            >
            <em class="txt-small">{{ item }}</em>
          </span>
        </span>
      </li>
    </ul>
    <!-- 현재대운 컬럼 -->
    <ul class="birth-item-box birth bg-line txt-big cur-daeun-col" :class="{ 'has-divider': !isAsc }" :style="{ order: isAsc ? 0 : 1 }">
      <li>
        <span v-if="getCurDaeunNum(prCurDaeun.sky) === prTransdata?.curlucknum" class="txt1">
          {{ daeunHeaderText }}
        </span>
        <span v-else class="txt1"> {{ getCurDaeunNum(prCurDaeun.sky) }} {{ daeunSuffix }} </span>
      </li>
      <li>
        <span class="txts">{{ getValueTxtD(prCurDaeun.sky, 'six') }}</span>
      </li>
      <li>
        <span
          class="txt-round xl"
          :class="[
            five.getColorFive(getValueTxtD(prCurDaeun.sky, 'value')),
            prLangMode === 'CHNKOR' ? 'chnkor' : '',
            prLangMode,
          ]"
        >
          <em v-if="prLangMode === 'CHNKOR'" class="chn">
            {{ five.getHanjaTxt(getValueTxtD(prCurDaeun.sky, 'value'), 'sky') }}
          </em>
          <em class="txt-main">{{ getValueTxtD(prCurDaeun.sky, 'value') }}</em>
        </span>
      </li>
      <li>
        <span
          class="txt-round xl mb6"
          :class="[
            five.getColorFive(getValueTxtD(prCurDaeun.earth, 'value')),
            prLangMode === 'CHNKOR' ? 'chnkor' : '',
            prLangMode,
          ]"
        >
          <em v-if="prLangMode === 'CHNKOR'" class="chn">
            {{ five.getHanjaTxt(getValueTxtD(prCurDaeun.earth, 'value'), 'earth') }}
          </em>
          <em class="txt-main">{{ getValueTxtD(prCurDaeun.earth, 'value') }}</em>
        </span>
      </li>
      <li>
        <span class="txts">{{ getValueTxtD(prCurDaeun.earth, 'six') }}</span>
      </li>
      <li class="st-none-ys">
        <span class="txts txt-earth-02">{{ getValueTxtD(prCurDaeun.earth, 'twelve') }}</span>
      </li>
      <li class="st-none-ys">
        <span class="txts txt-earth-02">{{ getValueTxtD(prCurDaeun.earth, 'sal') }}</span>
      </li>
      <!-- <li

        class="jijangan st-row"
      >
        <span class="txt-xs">
          <span
            v-for="(item, index2) in getValueTxtD(prCurDaeun.earth, 'jijanggan')"
            :key="index2"
          >
            <em>{{ item }}</em>
          </span>
        </span>
      </li> -->
      <li class="jijangan">
        <span class="txt-group-root">
          <span
            v-for="(item, index2) in getValueTxtD(prCurDaeun.earth, 'jijanggansix')"
            :key="index2"
            class="txt-group"
          >
            <em
              class="txt-big ganji-txt"
              :class="[
                five.getColorFive(getValueTxtDOne(prCurDaeun.earth, 'jijanggan', index2)),
                prLangMode === 'CHNKOR' ? 'chnkor' : '',
              ]"
              >{{ getValueTxtDOne(prCurDaeun.earth, 'jijanggan', index2) }}</em
            >
            <em class="txt-small">{{ item }}</em>
          </span>
        </span>
      </li>
    </ul>
    <ul v-for="(char, index) in prBirthTitle" :key="index" class="birth-item-box birth txt-big" :style="{ order: index + 2 }">
      <li>
        <span class="txt1">{{ getDisplayTitle(char) }}</span>
      </li>
      <li>
        <span class="txts">{{ getYearSix(prBirthData?.sky, char) }}</span>
      </li>
      <li>
        <span
          class="txt-round xl"
          :class="[
            five.getColorFive(getValueTxt(prBirthData?.sky, char, 'value')),
            getClass('sky', char, prBirthTitle),
            prLangMode === 'CHNKOR' ? 'chnkor' : '',
            prLangMode,
          ]"
        >
          <em v-if="prLangMode === 'CHNKOR'" class="chn">
            {{ five.getHanjaTxt(getValueTxt(prBirthData?.sky, char, 'value'), 'sky') }}
          </em>
          <em v-if="getValueTxt(prBirthData?.sky, char, 'value') === '-'" class="time-none">{{
            getValueTxt(prBirthData?.sky, char, 'value')
          }}</em>
          <em v-else class="txt-main">{{ getValueTxt(prBirthData?.sky, char, 'value') }}</em>
        </span>
      </li>
      <li>
        <span
          class="txt-round xl mb6"
          :class="[
            five.getColorFive(getValueTxt(prBirthData?.earth, char, 'value')),
            getClass('earth', char, prBirthTitle),
            prLangMode === 'CHNKOR' ? 'chnkor' : '',
            prLangMode,
          ]"
        >
          <em v-if="prLangMode === 'CHNKOR'" class="chn">
            {{ five.getHanjaTxt(getValueTxt(prBirthData?.earth, char, 'value'), 'earth') }}
          </em>
          <em v-if="getValueTxt(prBirthData?.sky, char, 'value') === '-'" class="time-none">{{
            getValueTxt(prBirthData?.sky, char, 'value')
          }}</em>
          <em v-else class="txt-main">{{ getValueTxt(prBirthData?.earth, char, 'value') }}</em>
          <!--여기-->
        </span>
      </li>
      <li>
        <span class="txts">{{ getYearSix(prBirthData?.earth, char) }}</span>
      </li>
      <li class="st-none-ys">
        <span class="txts txt-earth-02">{{ getValueTxt(prBirthData?.earth, char, 'twelve') }}</span>
      </li>
      <li class="st-none-ys">
        <span class="txts txt-earth-02">{{ getValueTxt(prBirthData?.earth, char, 'sal') }}</span>
      </li>
      <!-- <li

        class="jijangan"
      >
        <span class="txt-xs">
          <span
            v-for="(item, index2) in getValueTxt(prBirthJijanggan, char, 'jiji')"
            :key="index2"
          >
            <em>{{ item }}</em>
          </span>
        </span>
      </li> -->
      <li class="jijangan">
        <span class="txt-xs txt-group-root">
          <span
            v-for="(item, index2) in getValueTxt(prBirthJijanggan, char, 'six')"
            :key="index2"
            class="txt-group"
          >
            <em v-if="char === '시' && item === '-'" class="txt-big ganji-txt">{{ item }}</em>
            <em
              v-if="char !== '시' || item !== '-'"
              class="txt-big ganji-txt"
              :class="[
                five.getColorFive(getValueTxtOne(prBirthJijanggan, char, 'jiji', index2)),
                prLangMode === 'CHNKOR' ? 'chnkor' : '',
              ]"
              >{{ getValueTxtOne(prBirthJijanggan, char, 'jiji', index2) }}</em
            >
            <em v-if="char !== '시' || item !== '-'" class="txt-small">{{ item }}</em>
          </span>
        </span>
      </li>
    </ul>
    </div>
  </div>
</template>
<style lang="scss">
// 모바일 사주 컬럼 sticky (스크롤 시 상단 고정)
.saju-sticky-columns {
  position: fixed;
  z-index: 100;
  background: #fff;
  box-shadow: none;
  will-change: transform;
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;

  .saju-sticky-columns__inner {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    gap: 0 !important;
    padding: 12px 0 !important;
    overflow-x: hidden !important;
    background: #fff !important;
    width: 100% !important;
    justify-content: center !important;

    // 대운/사주 컬럼 공통
    .birth-item-box {
      display: flex !important;
      flex-direction: column !important;
      flex: 1 1 0 !important;
      min-width: 0 !important;
      max-width: none !important;
      border-right: none !important;
      padding: 0 !important;
      margin: 0 !important;
      align-items: center !important;
      box-sizing: border-box !important;
      gap: 4px !important;

      // 현재세운/현재대운 컬럼
      &.bg-line {
        background: transparent !important;
        border: none !important;
        border-radius: 0 !important;
        position: relative !important;

        // 현재세운/현재대운은 오행 box 44px, border-radius 10px (피그마 기준)
        .txt-round.xl {
          width: 44px !important;
          height: 44px !important;
          border-radius: 10px !important;

          &.chnkor .chn {
            font-size: 24px !important;
            line-height: 24px !important;
          }
          &.chnkor .txt-main {
            font-size: 12px !important;
            line-height: 12px !important;
          }
          .txt-main {
            font-size: 24px !important;
          }
        }

        // 천간/지지 행 - 피그마 기준 p-[6px] gap-[18px]
        li:nth-child(3) {
          padding: 6px 0 9px 0 !important;
        }
        li:nth-child(4) {
          padding: 9px 0 6px 0 !important;
        }

        // 구분선: 사주4주와 인접한 컬럼(has-divider)의 오른쪽에 표시
        &.has-divider::after {
          content: '' !important;
          position: absolute !important;
          right: 2.5px !important;
          top: 20px !important;
          bottom: 12px !important;
          width: 1px !important;
          background: #e5e5e5 !important;
        }
      }

      li {
        width: 100% !important;
        height: auto !important;
        min-height: 18px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        border-bottom: none !important;
        padding: 0 !important;
        box-sizing: border-box !important;
        list-style: none !important;

        &:first-child {
          height: 18px !important;
          background: transparent !important;
          margin-bottom: 0 !important;
        }

        // 십성 행
        &:nth-child(2) {
          height: 18px !important;
          margin-bottom: 0 !important;
        }

        // 천간/지지 행
        &:nth-child(3),
        &:nth-child(4) {
          height: auto !important;
          padding: 3px 0 !important;
        }

        // 타이틀
        .txt1 {
          font-size: 14px !important;
          color: #757575 !important;
          font-weight: 400 !important;
          white-space: nowrap !important;
        }

        // 십성 텍스트
        .txts {
          font-size: 14px !important;
          color: #333 !important;
          font-weight: 400 !important;
        }

        // 천간/지지 둥근 버튼 - 피그마 기준: 사주4주 54px/12px, 세운/대운 44px/10px
        .txt-round.xl {
          width: 54px !important;
          height: 54px !important;
          border-radius: 12px !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          position: relative !important;
          overflow: hidden !important;

          // 한자+한글 모드 (54px 박스 - 한자 왼쪽 위, 한글 오른쪽 아래 - PC와 동일)
          &.chnkor {
            .chn {
              font-size: 30px !important;
              line-height: 30px !important;
              font-weight: 400 !important;
              opacity: 1 !important;
              position: absolute !important;
              top: 6px !important;
              left: 6px !important;
              transform: none !important;
            }

            .txt-main {
              font-size: 13px !important;
              line-height: 13px !important;
              font-weight: 400 !important;
              position: absolute !important;
              bottom: 4px !important;
              right: 4px !important;
            }
          }

          .txt-main {
            font-size: 32px !important;
            font-weight: 400 !important;
            line-height: 1 !important;
          }
        }
      }

      // 하단 텍스트 (십성, 12운성, 신살)
      li:nth-child(n + 5) {
        height: 18px !important;
        margin-top: 0 !important;

        .txts {
          font-size: 14px !important;
          color: #333 !important;
        }
      }

      // 십이운성, 십이신살
      .st-none-ys {
        display: flex !important;
        height: 18px !important;

        .txts {
          font-size: 14px !important;
          color: #757575 !important;
        }
      }

      // 지장간 행 - 모바일에서는 앞 글자만 한 줄로 표시
      .jijangan {
        height: 18px !important;
        min-height: unset !important;
        padding: 0 !important;

        .txt-group-root {
          display: flex !important;
          flex-direction: row !important;
          gap: 0 !important;
          align-items: center !important;
          justify-content: center !important;
        }

        .txt-group {
          display: flex !important;
          align-items: center !important;
          gap: 0 !important;
          font-size: 14px !important;

          .txt-big {
            font-size: 14px !important;
          }

          .txt-small {
            display: none !important;
          }
        }
      }
    }
  }
}

// sticky 활성화 시 원래 컬럼은 그대로 두고 sticky가 위에 덮음 (부드러운 전환)

// PC 현재세운/현재대운 스타일
.data-0101-box:not(.mobile) {
  // 현재세운/현재대운 공통 - 오행 box 44px (피그마 기준)
  .bg-line .txt-round.xl {
    width: 44px !important;
    height: 44px !important;
    border-radius: 10px !important;

    &.chnkor .chn {
      font-size: 24px !important;
      line-height: 24px !important;
    }
    &.chnkor .txt-main {
      font-size: 12px !important;
      line-height: 12px !important;
    }
    .txt-main {
      font-size: 24px !important;
    }
  }

  // 천간/지지 행 - 피그마 기준 p-[6px] gap-[18px]
  .bg-line li:nth-child(3) {
    padding: 4px 0 0px 0 !important;
  }
  .bg-line li:nth-child(4) {
    padding: 9px 0 7px 0 !important;
  }

  // 현재세운 컬럼 - 테두리 없음
  .cur-seun-col.bg-line {
    border: none !important;
    border-radius: 0 !important;
  }

  // 현재대운 컬럼 - 기본 스타일
  .cur-daeun-col.bg-line {
    border: none !important;
    border-radius: 0 !important;
    position: relative;
  }

  // 구분선: 사주4주와 인접한 컬럼(has-divider)의 오른쪽에 표시
  .has-divider.bg-line {
    margin-right: 8px;

    &::after {
      content: '';
      position: absolute;
      right: -6px;
      top: 21px;
      bottom: 12px;
      width: 1px;
      background: #ebebeb;
    }
  }
}

.youngsin-manse-birth-box {
  .st-none-ys {
    display: none;
  }
  .data-0101-box {
    margin: 0 auto;
    &.mobile {
      width: 100%;
      overflow-x: auto;
    }
    &.mobile::-webkit-scrollbar {
      height: 8px;
    }
  }
  .birth-tit-box .row-box {
    list-style: none;
  }
  .data-0101-box .txt1 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: var(--Gray-600, #757575);
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
  }
  .birth-item-box .txts {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: var(--Gray-800, #333);
    text-align: center;
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
  }

  .birth-item-box {
    padding: 6px !important;
  }
}
</style>
